var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('vue-qrious',{staticClass:"qr",style:({'margin-top' : 'inherit'}),attrs:{"size":200,"value":_vm.qr_uri}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }